import { render, staticRenderFns } from "./vPedidos.vue?vue&type=template&id=945f4dba"
import script from "./vPedidos.vue?vue&type=script&lang=js"
export * from "./vPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports